import {
  AGENDA_FAQ,
  AGENDA_LANDING_H1,
  AGENDA_LANDING_PATH,
} from "./agendaLandingContent";
import { SITE_NAME, buildCanonicalUrl } from "@/lib/siteSeo";

export const AGENDA_SEO_TITLE =
  "Agenda Online para Barbearia | Meu Barbeiro PRO";

export const AGENDA_SEO_DESCRIPTION =
  "Organize a agenda da sua barbearia e ofereça agendamento online aos clientes. Horários claros, link público e gestão pelo painel. Teste grátis por 7 dias.";

export const AGENDA_PRIMARY_KEYWORD = "agenda online para barbearia";

export const AGENDA_SECONDARY_KEYWORDS = [
  "agendamento online para barbearia",
  "agenda para barbeiro",
  "agendamento para barbeiro",
  "link de agendamento",
  "agenda online",
];

export function buildAgendaSoftwareApplicationJsonLd(siteUrl: string) {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: SITE_NAME,
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    url: `${siteUrl}${AGENDA_LANDING_PATH}`,
    description: AGENDA_SEO_DESCRIPTION,
    offers: {
      "@type": "Offer",
      priceCurrency: "BRL",
      url: `${siteUrl}/register`,
      description:
        "Teste grátis de 7 dias; planos pagos a partir de R$ 29,90/mês",
    },
  };
}

export function buildAgendaFaqPageJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: AGENDA_FAQ.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };
}

export function buildAgendaBreadcrumbJsonLd(siteUrl: string) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Início",
        item: siteUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Agenda online para barbearia",
        item: `${siteUrl}${AGENDA_LANDING_PATH}`,
      },
    ],
  };
}

export function buildAgendaLandingJsonLd(siteUrl: string) {
  return [
    buildAgendaSoftwareApplicationJsonLd(siteUrl),
    buildAgendaFaqPageJsonLd(),
    buildAgendaBreadcrumbJsonLd(siteUrl),
  ];
}

export function assertAgendaLandingSeoContract() {
  return {
    h1: AGENDA_LANDING_H1,
    title: AGENDA_SEO_TITLE,
    description: AGENDA_SEO_DESCRIPTION,
    canonical: buildCanonicalUrl(AGENDA_LANDING_PATH),
    path: AGENDA_LANDING_PATH,
    hasPrimaryKeyword: AGENDA_LANDING_H1.toLowerCase().includes(
      AGENDA_PRIMARY_KEYWORD
    ),
  };
}
